@if (caseDetailInfo) {
  <div class="mx-5 case-detail">
    <div class="case-info-styles">
      <div class="col-md-12 d-flex flex-wrap mb-4 pl-0">
        <div class="col-md-3 pl-0">
          <label class="color-font font-text-600 mb-1">Case ID #</label>
          <div class="text-muted mb-2">{{caseDetailInfo?.svcCaseNumber}}</div>
          <label class="color-font font-text-600 mb-1">Case Type</label>
          <div class="text-muted mb-2">{{caseDetailInfo?.caseType}}</div>
          <label class="color-font font-text-600 mb-1">Date of Incident</label>
          <div class="text-muted mb-2">{{caseDetailInfo?.dateOfIncident}}</div>
        </div>
        <div class="col-md-3 pl-0">
          <label class="color-font font-text-600 mb-1">Created On</label>
          <div class="text-muted mb-2">{{caseDetailInfo?.createdOn}}</div>
          <label class="color-font font-text-600 mb-1">Job Name</label>
          <div class="text-muted mb-2">{{caseDetailInfo?.jobName || '-'}}</div>
          <label class="color-font font-text-600 mb-1">Case Description</label>
          <div class="text-muted mb-2 case-desc-styles">{{caseDescTextToDisplay}} @if (showReadMore) {
            <a
            (click)="showFullcaseDescText()">Read More</a>
          }</div>
        </div>
        <div class="col-md-3 pl-0">
          <label class="color-font font-text-600 mb-1">Sales Order #</label>
          <div class="text-muted mb-2">{{caseDetailInfo?.orderNumber}}</div>
          <label class="color-font font-text-600 mb-1">Last Updated</label>
          <div class="text-muted mb-2">{{caseDetailInfo?.lastUpdated}}</div>
          @if ((caseDetailInfo?.products && caseDetailInfo.products.length)) {
            <label class="color-font font-text-600 mb-1">Additional Details Product List</label>
            @for (eachProduct of caseDetailInfo.products; track eachProduct) {
              <div class="text-muted">
                {{eachProduct}}
              </div>
            }
          }
          @if ((caseDetailInfo?.deliveredSku && caseDetailInfo?.requestedSku)) {
            <label class="color-font font-text-600 mb-1">SKU</label>
            <div class="text-muted">Requested - {{caseDetailInfo.requestedSku}}</div>
            <div class="text-muted">Delivered - {{caseDetailInfo.deliveredSku}}</div>
          }
        </div>
        <div class="col-md-3 pl-0">
          <label class="color-font font-text-600 mb-1">Document #</label>
          <div class="text-muted mb-2">{{caseDetailInfo?.documentNumber || '-'}}</div>
          <label class="color-font font-text-600 mb-1">Status</label>
          <div class="status mb-2">{{caseDetailInfo?.status | uppercase}}</div>
          <label class="color-font font-text-600 mb-1">Attachments</label>
          @for (eachAttachment of caseDetailInfo?.attachments; track eachAttachment) {
              @if (eachAttachment?.fileURL) {
              <a [href]="eachAttachment.fileURL" target="_blank" rel="noopener noreferrer" class="doc-link doc-attachment">
                {{ eachAttachment.mediaName }}
              </a>
              } @else {
              <div (click)="downloadAttachment(eachAttachment)" class="doc-link doc-attachment">
                {{ eachAttachment.fileName }}
              </div>
              }
          }
        </div>
      </div>
    </div>
    <div>
      <hr class="mt-3 col-12 float-left">
    </div>
    <div class="conversation-styles">
      <div class="col-12 d-flex justify-content-between pl-0 pr-0 mb-3">
        <div class="label-heading sub-header pl-0 pt-2">Conversation History</div>
        @if (caseDetailInfo?.status !== 'Closed') {
          <div class="label-heading sub-header pl-0 button-tooltip">
            <button class="btn btn-primary" (click)="handleCaseDetailUpdateClick()">Add Comments or Attachments</button>
            <span ngbTooltip="{{addCommentsToolTipText}}" triggers="hover" placement="top-right">
              <img src="images/info_icon.svg" class="pb-1 pl-1">
            </span>
          </div>
        }
      </div>
      @for (commentItem of caseDetailInfo.ticketEvents; track commentItem) {
        <div class="comment-styles">
          <div class="d-flex justify-content-between pt-2">
            <div class="label-heading">{{commentItem.author}}</div>
            <div class="date-styles">{{commentItem.startDateTime}}</div>
          </div>
          <div class="comment-notes-styles">
            <div class="pb-2">
              {{commentItem.text}}
            </div>
          </div>
          <div class="attachment">
            @if (commentItem.attachments && commentItem.attachments.length) {
              @for (eachAttachment of commentItem.attachments; track eachAttachment) {
                <div (click)="downloadAttachment(eachAttachment)">{{eachAttachment.fileName}}</div>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
}
